import { render } from "./income.vue?vue&type=template&id=ccb73c66&scoped=true"
import script from "./income.vue?vue&type=script&lang=js"
export * from "./income.vue?vue&type=script&lang=js"

import "./income.vue?vue&type=style&index=0&id=ccb73c66&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb73c66"]])

export default __exports__